<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      v-if="isMobile"
    >
      <v-list dense>
        <drawer-item v-for="item in items" :key="item.to"
          :to="item.to"
          :icon="item.icon"
          :title='item.title'
        />
        <locale-changer-drawer />
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      fixed
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="isMobile"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <!-- <router-link to="/" class="home text-decoration-none">

        </router-link> -->
        <a :href="web_home_url" target="_blank">
          <v-img
            contain
            src="@/assets/logo.png"
            width="120"
            height="60"
          ></v-img>
        </a>
      </v-toolbar-title>
      <!-- <v-spacer></v-spacer> -->

      <v-spacer></v-spacer>
      <template v-if="!isMobile">
        <nav-item v-for="item in items" :key="item.to"
          :to="item.to"
          :icon="item.icon"
          :title="item.title"
          :color="item.color"
        />
        <locale-changer ></locale-changer>
      </template>

    </v-app-bar>
  </div>
</template>

<script>
import common from '@/components/mixin/common'
import { DrawerItem, NavItem } from '@/components/nav'
import { LocaleChanger, LocaleChangerDrawer } from '@/components/local'
export default {
  name: 'BaseNav',
  mixins: [common],
  components: {
    LocaleChanger,
    LocaleChangerDrawer,
    DrawerItem,
    NavItem
  },
  data () {
    return {
      web_home_url: process.env.VUE_APP_DOMAIN,
      drawer: false
    }
  },
  props: {
    items: {
      default: () => {
        return []
      },
      type: Array
    }
  }
}
</script>
